const upgradePersonal = {
  bannerTitle: 'HitPaw ऑनलाइन परम',
  introduct:
    'एन्हांसर, रिमूवर, एआई ट्रांसलेटर, स्क्रीन रिकॉर्डर, और बहुत कुछ सहित पूर्ण सुइट में 35 से अधिक टूल्स प्रीमियम सुविधाओं का उपयोग एक, सस्ती कीमत पर उपलब्ध है।',
  Upgrade: 'उन्नत करना',
  Tools: 'औजार',
  MyProjects: 'मेरे प्रोजेक्ट',
  MyAccount: 'मेरा खाता',
  Subscription: 'अंशदान',
  LogOut: 'लॉग आउट',
  PopularTools: 'लोकप्रिय उपकरण',
  Enhance: 'बढ़ाना',
  Remove: 'निकालना',
  Animate: 'चेतन',
  Extract: 'निकालना',
  SaveThreeDays:
    'प्रोजेक्ट 3 दिनों के लिए संग्रहीत हैं, कृपया प्रसंस्करण के बाद उन्हें डाउनलोड करें।',
  All: 'सभी',
  Video: 'वीडियो',
  Image: 'छवि',
  Audio: 'ऑडियो',
  minutesAgo: 'कुछ मिनट पहले',
  hoursAgo: 'घंंटों पहले',
  daysAgo: 'दिन पहले',
  Modified: 'संशोधित',
  Order: 'आदेश',
  EarliestToLatest: 'प्रारंभिक से नवीनतम',
  LatestToEarliest: 'नवीनतम से आरंभिक तक',
  NoProject: 'अभी तक कोई प्रोजेक्ट नहीं. शीघ्र शुरुआत करें',
  OnlineTools: 'ऑनलाइन उपकरण',
  AIVideoEnhancer: 'एआई वीडियो एन्हांसर',
  Enhancer4K: 'एआई द्वारा एक-क्लिक से वीडियो को ऑनलाइन 4K तक बढ़ाया जा सकता है',
  AIPhotoEnhancer: 'एआई फोटो एन्हांसर',
  AIEnhancerImage: 'एआई ऑनलाइन छवियों को दोषरहित तरीके से 8X तक बढ़ा देता है',
  View: 'देखना',
  Download: 'डाउनलोड करना',
  MultipleSelect: 'बहु-चयन',
  Delete: 'मिटाना',
  SubscriptionHistory: 'सदस्यता इतिहास',
  NoValidSubscription: 'कोई वैध सदस्यता नहीं.',
  veContent: 'एआई द्वारा एक-क्लिक से वीडियो को ऑनलाइन 4K तक बढ़ाया जा सकता है',
  peContent: 'एआई ऑनलाइन छवियों को दोषरहित तरीके से 8X तक बढ़ा देता है',
  rmvContent: 'वीडियो से वॉटरमार्क हटाएं',
  rmttContent: 'पलक झपकते ही हटाएं टिकटॉक वीडियो वॉटरमार्क',
  dynamicContent: 'अपनी फ़ोटो को ऑनलाइन एनिमेट करें',
  rmbgContent: 'छवि से पृष्ठभूमि हटाएँ',
  youMayNeed: 'आप को आवश्यकता हो सकती',
  new: 'नया',
  loginYourAccount: 'अपने हिटपॉ खाते में लॉगिन करें',
  signUpYourAccount: 'अपने हिटपॉ खाते में साइन अप करें',
  HitPawWatermark: 'Watermark Remover',
  HitPawTiktokWatermark: 'TikTok Watermark Remover',
  HitPawRemoveBg: 'Background Remover',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
